import { render, staticRenderFns } from "./AutomationRecipientPicker.vue?vue&type=template&id=56af1458&scoped=true&"
import script from "./AutomationRecipientPicker.vue?vue&type=script&lang=js&"
export * from "./AutomationRecipientPicker.vue?vue&type=script&lang=js&"
import style0 from "./AutomationRecipientPicker.vue?vue&type=style&index=0&id=56af1458&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56af1458",
  null
  
)

export default component.exports